import styled from 'styled-components';

const ClaroParagraph = styled.p`
    font-size: ${props => props.fontSize ? props.fontSize : "14px!important"}
    margin: ${props => props.margin ? props.margin : "0em 0em 0em 0em"}
    padding: ${props => props.padding ? props.padding : "0em 0em 0em 0em"}
    font-family: ${props => props.fontFamily ? props.fontFamily : "RobotoBold"}
    color: ${props => props.fontColor ? props.fontColor : "#50626c"}
    text-align: ${props => props.align ? props.align : "left"}
    font-weight: ${props => props.weight ? props.weight : "normal"}
    font-style: ${props => props.fontStyle ? props.fontStyle : "normal"}
`
export default ClaroParagraph;


